// Canonical listing categories. Selected in the admin listing form and used to
// filter listings on the public Listings page. Single source of truth so the
// admin dropdown and the public filter chips never drift apart.
export const LISTING_CATEGORIES = [
  "HDB (Resale)",
  "Condo (Resale)",
  "Condo (Sub-sale)",
  "Condo (New Launch)",
  "Landed",
  "Commercial / Industrial",
];

// When this category is selected, the listing form reveals an extra Type
// dropdown + an "Allowable trades" field.
export const COMMERCIAL_CATEGORY = "Commercial / Industrial";
export const COMMERCIAL_TYPES = ["B1", "B2", "Office", "Shophouse", "Others"];
